import { Component, ChangeDetectionStrategy } from '@angular/core';
import { GzToastHost } from '@gozem/ui';

/**
 * Notification Component
 * Renders the fixed toast stack via GzToastHost from @gozem/ui.
 * Place once in the main layout shell; GzToastService drives its content.
 */
@Component({
  selector: 'app-notification',
  standalone: true,
  imports: [GzToastHost],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationComponent {}
